import React from 'react';
import ServicePageTemplate from '@/components/ServicePageTemplate';

const QuadrantesPage: React.FC = () => {
  return <ServicePageTemplate serviceSlug="quadrantes" />;
};

export default QuadrantesPage;